module.exports = __webpack_public_path__ + "static/media/film-production-grid-1.c8b802b9.jpg";